<template>
  <div class="package-edit-form-container">
    <div class="component-list">
      <sp-tabs v-model="active_index" :tabs="tabs">
        <template #default="{ tabs }">
          <component-list :key="active_index" v-bind="tabs.length ? tabs[active_index].componentProps : {}" />
        </template>
      </sp-tabs>
    </div>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { unique } from '@/utils';
import { getPageConfig } from '@/views/auxiliary/title/config';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'sp-tabs': () => import('@/components/sp-tabs'),
    'component-list': () => import('./components/component-list/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 模块表单配置 */
    formFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /** 当前广告主活动索引 */
      active_index: 0,
      /** 标题配置 */
      page_config: {},
    };
  },
  computed: {
    tabs() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes.value.map(advertiser => {
        let assign_selection = unique(this.formFields.selection_config.list.filter(item => String(item.advertiser_id) === String(advertiser.advertiser_id)), 'id');
        assign_selection = unique(assign_selection, 'name');
        return {
          label: advertiser.label,
          componentProps: {
            formFields: this.formFields,
            advertiserId: advertiser.advertiser_id,
            assignSelection: assign_selection,
            pageConfig: this.page_config,
          },
        };
      });
    },
  },
  created() {
    const form_context = this.local_sharing_data.getFormContext();
    const { init_ops } = form_context.config;
    const { channel_interface } = init_ops;
    Object.assign(this.page_config, getPageConfig(`title-list-${channel_interface}`));
  },
  methods: {
    /**
     * 获取分配表单已选项
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      let assign_selection = this.tabs.reduce((prev, curr) => {
        return prev.concat(curr.componentProps.assignSelection.map(assign => Object.assign(assign, { advertiser_id: curr.componentProps.advertiserId })));
      }, []);
      assign_selection = unique(assign_selection, 'id');
      return Promise.resolve(assign_selection);
    },
  },
};
</script>

<style lang="scss" scoped>
.component-list {
  height: 500px;
}
</style>
